import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "rounded-xl w-full h-full bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 dark:from-primary-600 dark:via-primary-700 dark:to-primary-800 flex items-center justify-center z-10 relative overflow-hidden"
}
const _hoisted_2 = { class: "text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" }
const _hoisted_3 = { class: "text-white/90 text-lg md:text-xl font-medium" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "w-full flex flex-row justify-between" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "text-2xl lg:text-3xl font-bold text-neutral-200 w-full md:w-2/3 lg:w-2/3" }
const _hoisted_8 = { class: "flex flex-col md:flex-row w-full justify-between align-middle items-end space-y-4" }
const _hoisted_9 = { class: "text-sm lg:text-md w-full md:w-2/3 font-bold text-neutral-200 mt-5" }
const _hoisted_10 = { class: "w-full flex flex-row justify-between md:justify-end md:gap-x-3" }
const _hoisted_11 = { class: "flex flex-col md:flex-row lg:flex-col gap-y-3 border-l border-l-neutral-300 pl-2 sm:gap-x-2 align-middle" }
const _hoisted_12 = { class: "text-sm font-bold text-neutral-200" }
const _hoisted_13 = { class: "flex flex-col md:flex-row lg:flex-col gap-y-3 border-l border-l-neutral-300 pl-2 sm:gap-x-2 align-middle" }
const _hoisted_14 = { class: "text-sm font-bold text-neutral-200" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }

import type { SanityDocument } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";
import { motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  async setup(__props) {

let __temp: any, __restore: any

const { projectId, dataset } = useSanity().client.config();
const urlFor = (source) =>
  projectId && dataset ? imageUrlBuilder({ projectId, dataset }).image(source) : null;

const POSTS_QUERY = groq`*[
  _type == "post"
  && defined(slug.current)
  && publishedAt <= now()
  ]|order(publishedAt desc)[0...50]{
    _id,
    title,
    slug,
    image,
    publishedAt,
    description,
    body,
    category->{
      label,
      slug
    },
    author->{
      name,
      image {
        asset->{
          url
        }
      }
    }
  }`;

const { data: posts }: any = (
  ([__temp,__restore] = _withAsyncContext(() => useSanityQuery<SanityDocument[]>(POSTS_QUERY))),
  __temp = await __temp,
  __restore(),
  __temp
);
const processPosts = ref(null);

const featuredReadingTime = computed(() => calculateReadingTime(posts.value?.[0]?.body));

if (posts.value) {
  processPosts.value = posts.value
    .map((post) => {
      return {
        ...post,
        image: post.image ? urlFor(post.image).width(550).height(310).url() : null,
        date: formatDateString(post.publishedAt),
        readingTime: calculateReadingTime(post.body),
        authors: [
          {
            ...post.author,
            avatar: {
              src: post.author?.image ? urlFor(post.author.image).width(50).height(50).url() : null,
              // to: '',
              target: "_blank",
            },
          },
        ],
      };
    })
    .slice(1);
}

defineOgImage("MainOg", {
  title: "FamilyAxis",
  description: "FamilyAxis Blog Articles",
  theme: "#f5f5f5",
  colorMode: "light",
});

useSeoMeta({
  title: "FamilyAxis Journal",
  description: "FamilyAxis Blog Articles",
});

return (_ctx: any,_cache: any) => {
  const _component_UBadge = _resolveComponent("UBadge")!
  const _component_UBlogPost = _resolveComponent("UBlogPost")!
  const _component_UBlogPosts = _resolveComponent("UBlogPosts")!
  const _component_ClientOnly = _resolveComponent("ClientOnly")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, null, {
        default: _withCtx(() => [
          _createVNode(_component_UPageBody, null, {
            default: _withCtx(() => [
              _createVNode(_unref(motion).div, {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                transition: { duration: 0.5 },
                class: "w-full max-h-3/4 aspect-[16/9] relative my-10 flex justify-center flex-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(motion).div, {
                    initial: { opacity: 0, scale: 0.98 },
                    animate: { opacity: 0.5, scale: 1 },
                    transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1] },
                    class: "w-full h-full absolute rounded-xl border border-primary-100 dark:border-slate-800 bg-[linear-gradient(to_bottom,transparent_0%_1.3em,theme(colors.primary.100)_1.4em),linear-gradient(to_right,transparent_0%_1.3em,theme(colors.primary.200)_1.4em)] dark:bg-[linear-gradient(to_bottom,transparent_0%_1.3em,theme(colors.slate.800)_1.4em),linear-gradient(to_right,transparent_0%_1.3em,theme(colors.slate.800)_1.4em)] bg-[length:1.4em_1.4em] z-0 md:z-20"
                  }),
                  (_unref(posts)[0].image?.asset?._ref)
                    ? (_openBlock(), _createBlock(_unref(motion).img, {
                        key: 0,
                        src: urlFor(_unref(posts)[0].image).width(1600).height(900).url(),
                        initial: { opacity: 0, scale: 1.05 },
                        animate: { opacity: 1, scale: 1 },
                        transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1] },
                        auto: "format",
                        fit: "cover",
                        class: "rounded-xl w-full h-full object-cover z-10"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1),transparent_70%)]" }, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute top-0 left-0 w-32 h-32 bg-white/5 rounded-full -translate-x-16 -translate-y-16" }, null, -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-24 translate-y-24" }, null, -1)),
                        _createVNode(_unref(motion).div, {
                          initial: { opacity: 0, y: 20 },
                          animate: { opacity: 1, y: 0 },
                          transition: { duration: 0.6, delay: 0.2 },
                          class: "relative z-10 text-center px-8 py-12"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(posts)[0].title), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-16 h-1 bg-white/60 rounded-full mx-auto mb-4" }, null, -1)),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(posts)[0].category.label), 1)
                          ]),
                          _: 1
                        })
                      ])),
                  _createElementVNode("a", {
                    href: `/blog/${_unref(posts)[0].slug.current}`,
                    class: "mt-9 md:mt-0 lg:mt-0"
                  }, [
                    _createVNode(_unref(motion).div, {
                      initial: { opacity: 0, y: 30 },
                      animate: { opacity: 1, y: 0 },
                      transition: { duration: 0.6, delay: 0.3, ease: [0.25, 1, 0.5, 1] },
                      "while-hover": { scale: 1.01 },
                      class: "sm:w-full lg:w-[calc(100%-2.5rem)] min-h-48 p-5 sm:mt-10 sm:relative md:relative lg:absolute bottom-5 lg:left-5 z-20 rounded-xl backdrop-blur-md bg-neutral-800/50 hover:bg-neutral-900/70 transition-all duration-500"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-sm md:text-md font-bold text-neutral-200" }, "Featured", -1)),
                          _createVNode(_component_UBadge, {
                            color: "primary",
                            variant: "outline",
                            class: "text-sm font-bold"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(posts)[0].category.label), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(posts)[0].title), 1),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(posts)[0].description), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs font-semibold text-neutral-200" }, "Written by", -1)),
                                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(posts)[0].author.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs font-semibold text-neutral-200" }, "Published on", -1)),
                                _createElementVNode("div", _hoisted_14, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateString(_unref(posts)[0].publishedAt)), 1),
                                  (_unref(featuredReadingTime) > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, " · " + _toDisplayString(_unref(featuredReadingTime)) + " min read", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_4)
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-md font-bold text-neutral-900 dark:text-neutral-200 my-7" }, " Recent Blog Posts ", -1)),
              (_unref(posts))
                ? (_openBlock(), _createBlock(_component_UBlogPosts, {
                    key: 0,
                    orientation: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processPosts), (post) => {
                        return (_openBlock(), _createBlock(_component_UBlogPost, _mergeProps({
                          key: post.id
                        }, { ref_for: true }, post, {
                          to: `/blog/${post.slug.current}`,
                          badge: { label: `${post.category.label}` },
                          orientation: "vertical"
                        }), {
                          date: _withCtx(() => [
                            _createTextVNode(_toDisplayString(post.date), 1),
                            (post.readingTime > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " · " + _toDisplayString(post.readingTime) + " min read", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1040, ["to", "badge"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ClientOnly)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})